// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"13fe4f35","310":"fd246b73","453":"a035c682","539":"89921cef"}[chunkId] + ".chunk.js";
};